<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25.33 24.18A11 11 0 017.76 20H21a1 1 0 000-2H7.19a10.62 10.62 0 010-4H21a1 1 0 000-2H7.76a11 11 0 0117.57-4.18 1 1 0 001.34-1.49A13 13 0 005.64 12H4a1 1 0 000 2h1.17A13.16 13.16 0 005 16a13.16 13.16 0 00.17 2H4a1 1 0 000 2h1.64a13 13 0 0021 5.67 1 1 0 00-1.34-1.49z"/></svg>